jQuery(document).ready(function(){
  "use strict";
  jQuery.fn.scrollCenter = function(elem, effect) {
    var activeEle = jQuery(this).find(elem);
    var activeEleWidth = activeEle.width() / 2;

    var pos = activeEle.position().left + activeEleWidth;
    var eleCurrentPos = jQuery(this).scrollLeft();
    var wrapperWidth = jQuery(this).width();
    pos = pos + eleCurrentPos - wrapperWidth / 2; 
    //jQuery(this).scrollLeft(pos);
    //$('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 500, 'linear');
    if(typeof effect != 'undefined' && effect){
      jQuery(this).animate({ scrollLeft: pos}, 500, 'linear');
    }else{
      jQuery(this).scrollLeft(pos);
    }
  };

  //Slider JS
  var swiper = '';
  var sliderNavigation = {nextEl:".swiper-button-next", prevEl:".swiper-button-prev"};
  var sliderPagination = {el: ".swiper-pagination", dynamicBullets: true, clickable: true};
  
  var carousels = jQuery('[data-ele="swiper-carousel"]');
  if(typeof carousels != 'undefined' && carousels.length ){
    carousels.each(function( index ) {
      var _this = jQuery(this);
      //var sliderContainer = _this.find('[data-ele="swiper-wrapper"]');
      var eleId = _this.attr('id');
      //var eleId = sliderContainer.attr('id');
      var sliderOptions = _this.attr('data-slider-json');
      var sliderItems = _this.attr('data-slider-items');
      try {
        var desktopWidth = 2000;
        var documentWidth = jQuery(document).width();
        sliderOptions = JSON.parse(sliderOptions);
        sliderOptions.resistanceRatio = 0;
        var speed = 5000;
        if(typeof sliderOptions.speed != 'undefined'){
          var speed = parseInt(sliderOptions.speed) * parseInt(1000);
          sliderOptions.speed = speed; // converts Sec to milliseconds
        }

        if(typeof sliderOptions.autoplay_continuous != 'undefined' && sliderOptions.autoplay_continuous == true){
          if(typeof sliderItems != 'undefined'){
            speed = (parseInt(speed) * parseInt(sliderItems));
            speed = (speed / (desktopWidth/documentWidth));
            
          }
          var autoplay = {
              delay: 0,
              disableOnInteraction: false
          }
          sliderOptions.autoplay = autoplay;
          sliderOptions.speed = speed;
        }
        
        
        if(sliderOptions && typeof sliderOptions.slidesPerView200 != 'undefined'){
          var slidesPerView200 = sliderOptions.slidesPerView200;
          var slidesPerView577 = sliderOptions.slidesPerView577;
          var slidesPerView768 = sliderOptions.slidesPerView768;
          var slidesPerView991 = sliderOptions.slidesPerView991;
          var slidesPerView1100 = sliderOptions.slidesPerView1100;
          
          if(typeof sliderOptions.slidesPerView200 != 'undefined' && sliderOptions.slidesPerView200 == 0){
            slidesPerView200 = 'auto';
          }
          if(typeof sliderOptions.slidesPerView577 != 'undefined' && sliderOptions.slidesPerView577 == 0){
            slidesPerView577 = 'auto';
          }
          if(typeof sliderOptions.slidesPerView768 != 'undefined' && sliderOptions.slidesPerView768 == 0){
            slidesPerView768 = 'auto';
          }
          if(typeof sliderOptions.slidesPerView991 != 'undefined' && sliderOptions.slidesPerView991 == 0){
            slidesPerView991 = 'auto';
          }
          if(typeof sliderOptions.slidesPerView1100 != 'undefined' && sliderOptions.slidesPerView1100 == 0){
            slidesPerView1100 = 'auto';
          }
          
          var breakpoints = {
            200: {
                slidesPerView: slidesPerView200,
                resistanceRatio : 0.85
            },
            577: {
                slidesPerView: slidesPerView577,
                resistanceRatio : 0.85
            },
            768: {
                slidesPerView: slidesPerView768,
                resistanceRatio : 0.85
            },
            991: {
                slidesPerView: slidesPerView991,
                resistanceRatio : 0.85
            },
            1100: {
                slidesPerView: slidesPerView1100,
                resistanceRatio : 0.85
            }
          }
        }
        
        sliderOptions.lazy = true;
        
        
        if(typeof sliderOptions.slidesPerView != 'undefined' && sliderOptions.slidesPerView == 0){
          sliderOptions.slidesPerView = 'auto';
        }
        
        
        // IF Thumbs Slider
        if(sliderOptions && typeof sliderOptions.thumbs_navigation != 'undefined' && sliderOptions.thumbs_navigation == true){
          var sliderThumbOptions = {
                                    lazy: true, 
                                    slidesPerView: 5,
                                    centeredSlides: true,
                                    slideToClickedSlide: true
                                  }
          sliderThumbOptions.breakpoints = breakpoints;
          sliderThumbOptions.loop = sliderOptions.loop;
          var swiperThumbs = new Swiper('#thumb-'+eleId, sliderThumbOptions); // Thumbs Slider
        }else{
          sliderOptions.breakpoints = breakpoints;
        }
        
        if(sliderOptions && typeof sliderOptions.show_navigation != 'undefined' && sliderOptions.show_navigation == true){
          sliderOptions.navigation = sliderNavigation;
        }else{
          sliderOptions.navigation = false;
        }
        
        if(sliderOptions && typeof sliderOptions.show_pagination != 'undefined' && sliderOptions.show_pagination == true){
          sliderOptions.pagination = sliderPagination;
        }

        // if(typeof sliderOptions.autoplay_continuous != 'undefined' && sliderOptions.autoplay_continuous == true){
        //   console.log(sliderOptions);
        // }

        
        if(sliderOptions && typeof sliderOptions.thumbs_navigation != 'undefined' && sliderOptions.thumbs_navigation == true){
          sliderOptions.centeredSlides = true;
        }
        var swiper = new Swiper('#'+eleId, sliderOptions); // Main Slider

        if(sliderOptions && typeof sliderOptions.thumbs_navigation != 'undefined' && sliderOptions.thumbs_navigation == true){
          swiperThumbs.controller.control = swiper;
          swiper.controller.control = swiperThumbs;
        }
        
      } catch(e) {
        console.error(e); // error in the above string (in this case, yes)!
      }
    });
  }
  
  //Products Details Page
  var initSpiceIcons = function(){
    var spicyContainer = jQuery('[data-ele="spice-level"]');
    if(spicyContainer && typeof spicyContainer != 'undefined' && spicyContainer.length){
      var iconsHtml = ''; 
      var iconsCustomClass = ''; 
      var iconSpiceEmpty = spicyContainer.attr('data-icon-empty');
      var iconSpiceFull = spicyContainer.attr('data-icon-full');
      var iconMild = spicyContainer.attr('data-icon-mild');
      
      var maxSpiceLevel = spicyContainer.attr('data-max-spice-level');
      var itemSpiceLevel = spicyContainer.attr('data-item-spice-level');
      var itemSpiceLabel = spicyContainer.attr('data-item-spice-label');
      var spicyText = '';
      
      if(itemSpiceLabel.toLowerCase() == 'mild'){
        iconsCustomClass += ' mild-icon';
        maxSpiceLevel = itemSpiceLevel = 1;
        iconSpiceEmpty = iconSpiceFull = iconMild;
      }else{
        spicyText = '<span class="spice-label">'+itemSpiceLabel+'</span>';
      }

      if(maxSpiceLevel < itemSpiceLevel){
        maxSpiceLevel = itemSpiceLevel;
      }
      
      var fullSpiceIcons = itemSpiceLevel;
      var emptySpiceIcons = (parseInt(maxSpiceLevel) - parseInt(itemSpiceLevel));

      for (let i = 0; i < maxSpiceLevel; i++) {
        var icon = iconSpiceEmpty;
        if(i < itemSpiceLevel){
          var icon = iconSpiceFull;
        }
        iconsHtml += '<span class="spice-icon '+iconsCustomClass+'"><img src="'+icon+'"></span>';
      }
      if(iconsHtml || spicyText){
        var innerHtml = iconsHtml+spicyText;
        spicyContainer.html(innerHtml);
        spicyContainer.detach().appendTo('.product__info-container [data-yotpo-section-id="product"], .product__info-container [data-block-handle="star_rating"], .product__info-container [data-block-handle="star-rating"]');
      }else{
        spicyContainer.hide();
      }
    }
  }
  initSpiceIcons();
  
  var nutritionTableEle = jQuery('[data-ele="nutrition-more-info-conainer"]');
  jQuery(document).on('click', '[data-ele="nutrition-more-info"]', function(){
    var _this = jQuery(this);
    var nutritionImage = _this.attr('data-image-url');
    if(nutritionImage){
      var nutritionImage = '<img src="'+nutritionImage+'">';
      nutritionTableEle.removeClass('hidden');
      nutritionTableEle.find('[data-ele="image-holder"]').html(nutritionImage);
    }
  });

  jQuery(document).on('click', '[data-ele="close-pop-up"]', function(){
    var _this = jQuery(this);
    nutritionTableEle.addClass('hidden');
  });

  //productPage Tabs
  var processTabs = function(clickedTabId){
    var id = clickedTabId;
    var parentContainer = jQuery('[data-tab-id="'+id+'"]').parents('[data-ele="product-info-details"]');
    parentContainer.find('[data-ele="tab"]').removeClass('active');
    parentContainer.find('[data-ele="tab-content"]').removeClass('active');
    jQuery('[data-tab-id="'+id+'"], [data-ele-id="'+id+'"]').addClass('active');
    //console.log(jQuery('.product_info_details_tabs .active').length);
    if(typeof jQuery('.product_info_details_tabs .active') != 'undefined' && jQuery('.product_info_details_tabs .active').length){
      jQuery('.product_info_details_tabs').scrollCenter(".active", 'linear');
    }
  }
  jQuery(document).on('click', '[data-ele="tab"]', function(e) {
    var clickedTabId = jQuery(this).attr('data-tab-id');
    processTabs(clickedTabId);
  });
  
  var initTabs = function(sectionId){
    var tabInitialized = false;
    var productTabs = jQuery('#'+sectionId+' [data-ele="tab"]');
    productTabs.each(function(index, element) {
      var tab = jQuery(element);
      var tabId =  tab.attr('data-tab-id');
      var tabContent = jQuery('[data-ele="tab-content"][data-ele-id="'+tabId+'"]');
      tabContent = tabContent.find('[data-content="true"]');
      if(typeof tabContent !== 'undefined' && tabContent.length > 0){
        if(tabInitialized == false){
          tabInitialized = true;
          processTabs(tabId);
        }
        jQuery('#'+sectionId).removeClass('hidden');
      }else{
        tab.addClass('hidden');
      }
    })
  };
  var setTabsSectionPosition = function (sectionId, sectionPosition){
    if(sectionPosition == 'inside_product_information'){
      var prodInfoTabsContainer = jQuery('[data-ele="product_tabs_container"]');
      if(prodInfoTabsContainer && typeof prodInfoTabsContainer != 'undefined' && prodInfoTabsContainer.length){
        jQuery('#'+sectionId).detach().appendTo('[data-ele="product_tabs_container"]');
      }else{
        jQuery('#'+sectionId).detach().appendTo('.product__info-container'); 
      }
    }
  }

  var productTabsSections = jQuery('[data-ele="product-info-details"]');
  productTabsSections.each(function(index, element) {
    var _this = jQuery(this);
    var sectionPosition = _this.attr('data-ele-position');
    var sectionId = _this.attr('id');
    initTabs(sectionId);
    setTabsSectionPosition(sectionId, sectionPosition);
  });
  //subscription widget Start HERE
  var checkSubscription = function() {
    var selectedVariantRadioEle = jQuery('variant-radios input[type="radio"]:checked');
    var isRechargeSubscription = selectedVariantRadioEle.attr('recharge-subscription');
    if (isRechargeSubscription == 'true') {
      selectedVariantRadioEle.parents('.product__info-container').removeClass('subscription_disabled');
    } else {
      selectedVariantRadioEle.parents('.product__info-container').addClass('subscription_disabled');
    }
  }
  var updateSubscriptionPrice = function() {
    //console.log('updateSubscriptionPrice');
    var selectedPurchasePlanEle = jQuery('[name="purchaseOption"]:checked');
    if(typeof selectedPurchasePlanEle != 'undefined' && selectedPurchasePlanEle.length){
      var purchasePlanVal = selectedPurchasePlanEle.val();
      var selectedPurchasePlanPrice = selectedPurchasePlanEle.parents('label').find('.rc-radio__label .price-label').text();
      jQuery('[data-ele="price-with-from-text"]').text(selectedPurchasePlanPrice);
      clearInterval(checkSubscriptionLoaded);
    }
  }
  
  jQuery(document).on('change', 'variant-radios input[type="radio"]', function() {
    checkSubscription();
    jQuery('[name="purchaseOption"][value="onetime"]').click();
  });
  
  jQuery(document).on('change', '[name="purchaseOption"]', function(){
    updateSubscriptionPrice();
  });

  //if(jQuery('.product__info-container').length){
    checkSubscription();
    updateSubscriptionPrice();
    var checkSubscriptionLoaded = setInterval(updateSubscriptionPrice, 1000);
    var checkIfSubscriptionLoaded = setInterval(checkSubscription, 1000);
  //}

  //subscription widget End HERE




function getParameterByName( name ){
  var regexS = "[\\?&]"+name+"=([^&#]*)", 
  regex = new RegExp( regexS ),
  results = regex.exec( window.location.search );
  if( results == null ){
    return "";
  } else{
    return decodeURIComponent(results[1].replace(/\+/g, " "));
  }
}
  
//Recipes Search Start Here
var articleItemsContainer = jQuery('.blog-articless');
var _input = jQuery('.search-filter-desktop').find('input[name="q"]');
var requestInit = false;
var handlebarObj = {};
var getArticles = function(){
    var queryVal = _input.val();
    if(queryVal.length){
      articleItemsContainer.find('.articles:not([data-ele="search-item"])').hide();
      jQuery('.pagination-wrapper').hide();
    }else{
      articleItemsContainer.find('.articles:not([data-ele="search-item"])').show();
      jQuery('.pagination-wrapper').show();
    }
    if(queryVal && requestInit == false){
      var blogType = _input.attr('[data-blog-type]');
      if(typeof blogType == 'undefined'){
        blogType = 'Recipes';
      }
      var blogCurrentTag = _input.attr('[data-blog-tags]');
      
      handlebarObj.searchQuery = queryVal;
      articleItemsContainer.find('[data-ele="search-item"]').remove();
      requestInit = true;
      const SHOP_URL = window.iskpro.base_url;
      const ACCESS_TOKEN = window.iskpro.access_token;
      const API_VERSION = window.iskpro.api_version;
      const GRAPHQL_URL = SHOP_URL+'/api/'+API_VERSION+'/graphql.json';

      //`//articles(first: 10, query: "(title:brook `+queryVal+` AND (tagged:`+blogCurrentTag+`))") {`
      let articleQuery = `
            query Blogs {
              blogs(first: 1, query: "title:`+blogType+`") {
                edges {
                  node {
                    title
                    articles(first: 12, query: "(title:brook `+queryVal+`)") {
                      edges {
                        node {
                          blog {
                            title
                          },
                          content,
                          id,
                          title,
                          handle,
                          onlineStoreUrl,
                          image{
                            url
                          },
                          metafield(namespace: "general", key: "related_products") {
                            value
                            id
                          }
                        }
                      }
                    }
                  }
                },
                pageInfo {
                  hasNextPage
                  endCursor
                  startCursor
                }
              }
            }
          `;
      
      var xhr = new XMLHttpRequest();
      xhr.open("POST", GRAPHQL_URL);
      xhr.setRequestHeader("Content-Type", "application/graphql");
      //xhr.setRequestHeader("X-Shopify-Access-Token", ACCESS_TOKEN);
      xhr.setRequestHeader("Shopify-Storefront-Private-Token", ACCESS_TOKEN);
      xhr.onreadystatechange = function () {
         if (xhr.readyState === 4) {
            initResponseData(xhr);
            requestInit = false;
         }
      };
      var data = articleQuery;
      xhr.send(data);
    }
}

  var initResponseData = function(xhr){
    var handlebarTemplate = jQuery('[data-ele="recipe-item-card"]').html();
    var compiledTemplate = Handlebars.compile(handlebarTemplate);
    if(typeof xhr != 'undefined' && xhr && xhr.status == 200 && typeof xhr.response != 'undefined' && xhr.response) {
      var response = xhr.response;
      try {
        var responseObject = JSON.parse(response);
        if (typeof responseObject != 'undefined' 
        && typeof responseObject.data != 'undefined'
        && typeof responseObject.data.blogs != 'undefined'
        && typeof responseObject.data.blogs.edges != 'undefined'
        && typeof responseObject.data.blogs.edges[0] != 'undefined'
        && typeof responseObject.data.blogs.edges[0].node != 'undefined'
        && typeof responseObject.data.blogs.edges[0].node.articles != 'undefined'
        && typeof responseObject.data.blogs.edges[0].node.articles.edges != 'undefined'
        && responseObject.data.blogs.edges[0].node.articles.edges != null
       ) {
          var articles = responseObject.data.blogs.edges[0].node.articles.edges;
          handlebarObj.articles = articles;
          var resultHtml = compiledTemplate(handlebarObj);
          articleItemsContainer.append(resultHtml);
        }
      } catch(e) {
        console.log(e); // error in the above string (in this case, yes)!
      }
    }
  }

  _input.attr('autocomplete', 'off').bind('change', function() {
    getArticles();
  })

  var initSearch = function(){
    var queryParameter = getParameterByName('q');
    _input.val(queryParameter);
    _input.trigger("change");
  }
  initSearch();
  jQuery(document).on('click', '.clear-search', function(){
        _input.val("").trigger("change");
    })
});





